import { emptyFieldError } from './generic-validator';

export function validateEmail(value: string): string {
    if (!value) {
        return emptyFieldError;
    }
    return isValidEmail(value)
        ? ''
        : 'A valid email address needs to be entered';
}

function isValidEmail(email: string): boolean {
    const emailRegex =
        /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){2}\d{1,3}.\d{1,3}])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/;

    return emailRegex.test(email);
}
